/* eslint-disable camelcase */
<template>
  <div v-role="'func'">
    <div>
      <!--============= CADASTAR ESTUDANTE ===============-->
      <v-dialog v-model="dialog" max-width="1000px" max-heigh="600px" :key="contadorAbertura + '-cadstrar-estudante'">
        <v-card>
          <v-card-title>
            <div style="display: flex; justify-content: space-between; width: 100%">
              <div> 
                <span class="text-h5">
                  Cadastrar
                  <span v-if="idclasse === 1"> 10ª classe</span>
                  <span v-if="idclasse === 2"> 11ª classe</span>
                  <span v-if="idclasse === 3"> 12ª classe</span>
                  <span v-if="idclasse === 4"> 13ª classe</span>
                </span>
              </div>

              <div>
                <v-btn text @click="close"><v-icon large color="primary">clear</v-icon></v-btn>
              </div>
            </div>
          </v-card-title>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-text>
              <v-container>
                  <div>
                    <div style=" display: flex; flex-direction: column; align-items: center;">
                      <v-row>
                        <v-col cols="12" sm="4" md="4">
                          <v-text-field ref="biField"  required :md="isBendizer"  :rules="ruleBI" v-model="editedItem.bi" :label="descricao" v-mask="mascara"></v-text-field>
                        </v-col>
                        <v-col md="3">
                          <v-switch :label="descricao" @change="outroDoc()"></v-switch>
                        </v-col>
                        <v-col class="d-flex" cols="4" sm="4" md="4" v-if="isBendizer">
                          <v-autocomplete v-model="editedItem.estudante" :items="estudantesPesquisa"
                             :search-input.sync="search" color="primary" item-text="nome"
                            item-value="nome" label="Nome do estudante" placeholder="Digite o nome do estudante"
                            prepend-icon="mdi-database-search" return-object
                            @change="SelecionaEstudante()"></v-autocomplete>
                        </v-col>
                        <v-col cols="5" sm="5" md="5" v-if="!isBendizer">
                          <v-text-field :disabled="!isDisabled" :rules="ruleTextRequired" v-model="editedItem.nome" label="Nome"></v-text-field>
                        </v-col>

                        <v-col cols="4" sm="4" md="4" :md="isBendizer ? '6' : '4'">
                          <template>
                            <v-menu ref="menubi" v-model="menubi" :close-on-content-click="false"
                              transition="scale-transition" offset-y full-width min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field :disabled="!isDisabled" readonly v-model="editedItem.dataemissaobi"
                                  :rules="[(v) => !!v || 'Campo obrigatorio!']" label="Data de emissão do BI"
                                  prepend-inner-icon="event" v-on="on"></v-text-field>
                              </template>
                              <v-date-picker ref="picker" max="2030-12-31" min="2005-01-01" v-model="datebi"
                                @change="saveDatebi"></v-date-picker>
                            </v-menu>
                          </template>
                        </v-col>

                        <v-col cols="4" sm="4" md="4">
                          <v-text-field :disabled="!isDisabled" v-model="editedItem.nomedopai" label="Filho de:"></v-text-field>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                          <v-text-field :disabled="!isDisabled" v-model="editedItem.nomedamae" label=" e de:"></v-text-field>
                        </v-col>

                        <v-col cols="4" sm="4" md="4">
                          <template>
                            <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                              transition="scale-transition" offset-y full-width min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field class="mt-3" :disabled="!isDisabled" readonly v-model="editedItem.datanascimento"
                                  :rules="[(v) => !!v || 'Campo obrigatorio!']" label="Data de nascimento"
                                  prepend-inner-icon="event" v-on="on"></v-text-field>
                              </template>
                              <v-date-picker ref="picker" v-model="date" max="2010-12-31" min="1970-01-01"
                                @change="saveDate"></v-date-picker>
                            </v-menu>
                          </template>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                          <v-combobox  :disabled="!isDisabled" :rules="ruleRequired" v-model="proviSelectedForComb" :items="provincias"
                            item-value="idProvicia" item-text="descricao" @change="loadMunicipioComb" chips
                            label="Natural de:"></v-combobox>
                        </v-col>
                        <v-col cols="4" sm="4" md="4">
                          <v-combobox :disabled="!isDisabled" :rules="ruleRequired" v-model="municSelectedForComb" :items="municipiosFiltered"
                            item-value="idMunicipio" item-text="descricao" chips label="Municipio"></v-combobox>
                        </v-col>
                      
                        <v-col cols="3" sm="3" md="3">
                          <v-combobox  :disabled="!isDisabled" v-model="editedItem.sexo" :rules="ruleRequired" item-value="idSexo"
                            item-text="descricao" :items="dropdowSexo" chips label="Sexo"></v-combobox>
                        </v-col>

                        <v-col cols="4" sm="4" md="4">
                          <v-text-field   class="mt-3"  :disabled="!isDisabled" v-model="editedItem.telefone" label="Telefone">
                          </v-text-field>
                        </v-col>

                        <v-col cols="5" sm="5" md="5">
                          <v-combobox  :disabled="!isDisabled" v-if="true" v-model="editedItem.curso" :rules="ruleRequired" item-value="idCurso"
                            item-text="descricao" @change="loadTurmaComb" :items="cursos" chips
                            label="Curso"></v-combobox>
                        </v-col>

                        <v-col cols="6" sm="6" md="6">
                          <v-combobox  :disabled="!isDisabled" id="turma" v-if="true" v-model="editedItem.turma" :rules="ruleRequired"
                            :value="null" item-value="idTurma" @change="obterCadastradosTurma()" item-text="turmadescricao" :items="turmasFiltered"
                            chips label="Turma"></v-combobox>
                            
                            <v-row  md="7" v-if="editedItem.turma">
                              <v-col md="12" class="text-body-2">
                                <span >
                                  Capacidade: <strong>{{( editedItem.turma !== null )?editedItem.turma.capacidade:''}}</strong>
                                </span>
                        
                                <span class="mx-1">|</span>
                        
                                <span >
                                  Cadastrados: <strong>{{( cadastradosTurma.length )?cadastradosTurma[0].quantidade:''}}</strong>
                                </span>

                                <span class="mx-1">|</span>
                      
                               <span  :class="{ 'red--text': vagasTurmaDisponiveis <= 0, 'black--text': vagasTurmaDisponiveis > 0 }">
                                Vagas: <strong>{{ vagasTurmaTexto }}</strong>
                              </span>
                              
                            </v-col>
                            </v-row>

                        </v-col>
                     
             
                      </v-row>
                    </div>
                  </div>
                
              </v-container>
            </v-card-text>
          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="close()"> cancelar </v-btn>
            <v-btn  color="green darken-1" text @click="save" :disabled="!valid || vagasTurma === 0"> Guardar </v-btn>
          </v-card-actions>
        </v-card>
   
      </v-dialog>

      <div class="formPosition">
        <v-progress-linear style="margin: 0 auto; height: 10px" :indeterminate="isLoading"
          v-show="isLoading"></v-progress-linear>
        <v-overlay v-model="overlay">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-data-table :headers="headers" :items="estudantes" :search="searchInDb" sort-by="data_" class="elevation-3">
          <template v-slot:top>
            <v-toolbar flat color="white">
              <v-divider class="mx-8" inset vertical></v-divider>
              <v-toolbar-title v-if="isNotCurrentAnolectivo" style="color: red">Cadastro de Estudantes do ano anterior
                da<span v-if="idclasse === 1">
                  10ª classe</span>
                <span v-if="idclasse === 2"> 11ª classe</span><span v-if="idclasse === 3"> 12ª classe</span>
                <span v-if="idclasse === 4"> 13ª classe</span>
              </v-toolbar-title>

              <v-toolbar-title v-else>Estudante<span v-if="idclasse === 1"> 10ª classe</span>
                <span v-if="idclasse === 2"> 11ª classe</span><span v-if="idclasse === 3"> 12ª classe</span>
                <span v-if="idclasse === 4"> 13ª classe</span>
              </v-toolbar-title>

              <v-divider class="mx-8" inset vertical></v-divider>
              <div class="flex-grow-1"></div>
              <v-row>
                <v-col>
                  <v-btn v-if="!AtingiuLimite" x-large fab dark color="primary" @click="abrirComponente()">
                    <v-icon dark>add</v-icon>
                  </v-btn>

                  <v-tooltip v-if="!config_estudantes_instituicao.length" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" x-large fab color="warning">
                        <v-icon dark>lock</v-icon>
                      </v-btn>
                    </template>
                    <span>Atingiu o limite de cadastramento de estudantes da
                      {{ getClasse(idclasse) }}.</span>
                  </v-tooltip>
                </v-col>
              </v-row>

              <!--  search  -->
              <div v-if="$store.state.hasMessage && cor == 'red'" :class="$store.state.classMessage">
                {{ $store.state.textMessage }}
              </div>

              <div class="flex-grow-1"></div>
              <v-btn v-if="searchInDb" @click="initialize(searchInDb)" text icon color="green">
                <v-icon>cached</v-icon>
              </v-btn>

              <v-btn to="/painelclasses" color="blue" fab small>
                <v-icon small color="white">arrow_back</v-icon>
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:item.action="{ item }">
            <v-icon disabled small class="mr-2" @click="editItem(item)">edit</v-icon>
            <v-icon disabled small @click="deleteItem(item)">delete</v-icon>
          </template>
          <template v-slot:no-data>
            Clica em + para adicionar novo estudante
          </template>
        </v-data-table>
      </div>
      <v-row v-if="config_estudantes_instituicao.length">
        <v-col md="12">
          <v-card style="margin: auto">
            <v-card-text>
              <v-row>
                <v-col md="12">
                  <span>Informações</span>
                  <hr />
                </v-col>
                <v-col md="12">
                  <span style="font-weight: bold; font-size: 14px">Nº Estudantes permitidos na
                    {{ getClasse(idclasse) }}:</span>
                  <v-chip>{{
                    config_estudantes_instituicao.length
                      ? config_estudantes_instituicao[0].quantidade
                      : ""
                  }}</v-chip>
                </v-col>
                <v-col md="12">
                  <span style="font-weight: bold; font-size: 14px">Nº Estudantes cadastrados:</span>
                  <v-chip>{{
                    config_estudantes_instituicao.length
                      ? cadastrados[0].cadastrados
                      : ""
                  }}</v-chip>
                </v-col>
                <v-col md="12" v-if="AtingiuLimite">
                  <span style="font-weight: bold"> ATT: </span><span
                    style="font-weight: bold; font-size: 14px; color: red">De
                    acordo com a estatística fornecida ao ITSL você atingiu
                    o limite de estudantes para a {{ getClasse(idclasse) }} para
                    o anolectivo
                    {{
                      anolectivoSelected.descricao === null ||
                        anolectivoSelected.descricao === undefined
                        ? anolectivoSelected
                        : anolectivoSelected.descricao
                    }}</span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="!config_estudantes_instituicao.length">
        <v-col md="12">
          <v-card style="margin: auto">
            <v-card-text>
              <v-row>
                <v-col md="12">
                  <span>Informações</span>
                  <hr />
                </v-col>
                <v-col md="12"> </v-col>
                <v-col md="12"> </v-col>
                <v-col md="12">
                  <span style="font-weight: bold"> ATT : </span><span
                    style="font-weight: bold; font-size: 14px; color: #006699">Estatística não configurada no
                    sistema.</span>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <GlobalSnackbar ref="snackbar" />
  </div>
</template>

<script>
import axios from "../../plugins/axios";
import { mask } from "vue-the-mask";
import Swal from "sweetalert2";
const ls = require("local-storage");

export default {
 
  directives: { mask },
  data: () => ({
    dropdowSexo: [
      { idSexo: "M", descricao: "Masculino" },
      { idSexo: "F", descricao: "Femenino" },
    ],
    existingBi: false,
    contadorAbertura: 0,
    datebi: null,
    date: null,
    overlay: false,
    descricao: "Nº do Bi",
    valid: false,
    menu: false,
    menubi: false,
    ano_actual: ls.get("anolectivo"),
    overlayPesquisa: false,
    cursos: [],
    isLoading: true,
    turmasAll: [],
    mascara: "#########-AA-###",
    turmasFiltered: [],
    municipiosAll: [],
    config_estudantes_instituicao: [],
    cadastrados: [],
    estudantesPesquisa: [],
    cor: "",
    municipiosFiltered: [],
    provincias: [],
    search: null,
    searchInDb: "",
    estudantes: [],
    isDisabled: false,
    dialog: false,
    y: "top",
    text: "mensagem nao setada.",
    ruleRequired: [(value) => !!value || "campo obrigatorio"],
    ruleTextRequired: [
      (value) => !!value || "campo obrigatório.",
      (value) =>
        (value || "").length <= 50 || "O máximo número de carácters atigidos",

      (value) => (value || "").length > 3 || "carácteres insuficientes",
      (value) => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/;
        return !pattern.test(value) || "Invalido.";
      },
    ],

    ruleBI: [(value) => value.length === 16 || "Minimo de caracteres exigido( 16 )"],

    headers: [
      {
        text: "Nome",
        align: "left",
        sortable: false,
        value: "nome",
      },

      { text: "Turma", value: "turma" },
      { text: "Bi", value: "bi" },
      { text: "Actions", value: "action", sortable: false },
    ],

    msg: "",
    outroDocmento: false,
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    cadastradosTurma:[],
    vagasTurma:0,
    editedItem: {
      estudante: null,
      pkPessoa: 0,
      bi: null,
      idPessoa: "",
      idMunicipio: null,
      idPerfil: null,
      nome: "",
      morada: "",
      telefone: "",
      autor: "",
      datanascimento: "",
      data_: "",
      status_2: "",
      email: "",
      sexo: "",
      nomedopai: "",
      nomedamae: "",
      dataemissaobi: null,
      bi: null,
      ResidenteEm: 1,
      instituicao: null,
      instituicaodescricao: "",
      curso: null,
      turma: null,
      numero_matricula: "",
    },
    defaultItem: {
      estudante: null,
      pkPessoa: 0,
      idPessoa: "",
      bi: "",
      idMunicipio: null,
      idPerfil: null,
      nome: "",
      morada: "",
      telefone: "",
      autor: "",
      datanascimento: "",
      data_: "",
      status_2: "",
      email: "",
      sexo: "",
      nomedopai: "",
      nomedamae: "",
      dataemissaobi: "",
      // eslint-disable-next-line no-dupe-keys  
      bi: "",
      ResidenteEm: "",
      instituicao: "",
      instituicaodescricao: "",
      curso: null,
      turma: null,
      numero_matricula: "",
    },
    // firstStep: true,
    secondStep: true,
    studenteBi: null
  }),

  computed: {
    
    AtingiuLimite() {
      let result =
        (this.config_estudantes_instituicao.length
          ? parseInt(this.config_estudantes_instituicao[0].quantidade)
          : 0) -
        (this.cadastrados.length
          ? parseInt(this.cadastrados[0].cadastrados)
          : 0);
      this.dialog = result > 0;
      return result <= 0;
    },

  vagasTurmaDisponiveis() {
    const capacidade = this.editedItem.turma ? parseInt(this.editedItem.turma.capacidade) : 0;
    const cadastrados = this.cadastradosTurma.length ? parseInt(this.cadastradosTurma[0].quantidade) : 0;
    const vagas = capacidade - cadastrados;

    this.vagasTurma = vagas;
    return vagas;
  },
  vagasTurmaTexto() {
    return this.vagasTurma > 0 ? this.vagasTurma : 'Excedeu o limite de vagas.';
  },

    anolectivoSelecionado() {
      return this.anolectivoSelected.descricao === null ||
        this.anolectivoSelected.descricao === undefined
        ? this.anolectivoSelected
        : this.anolectivoSelected.descricao;
    },

    isNotCurrentAnolectivo() {
      return this.anolectivoSelecionado !== ls.get("anolectivo");
    },

    anolectivoSelected() {
      return this.$store.state.anolectivoSelected;
    },

    idclasse() {
      return this.$store.state.idclasse;
    },

    textMessage() {
      return this.$store.state.textMessage;
    },
    classMessage() {
      return this.$store.state.classMessage;
    },
    hasMessage() {
      return this.$store.state.hasMessage;
    },

    isBendizer() {
      return (
        window.location.host.includes("bendizer") ||
        window.location.host.includes("ilhaverdade")
      );
    },
  },

  watch: {
    menu(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },
    menubi(val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    },

    'editedItem.bi'() {
      this.$nextTick(() => {
        if (this.$refs.biField) {
          if( this.$refs.biField.validate() ) {
            this.checkDocNumber();
          }else{
            this.isDisabled=false;
          }
         
        }
      })
    },

    estudantes() {
      this.isLoading = false;
      this.$store.state.isloading = false;
    },
    dialog(val) {
      val || this.close();
    },
    search(val) {
      // Items have already been loaded
      // this.estudantes = [
      if (val.length > 3) {
        // Items have already been requested
        if (
          !this.estudantesPesquisa.filter((t) => t.nome.includes(val)).length
        ) {
          this.estudantesPesquisa = [];
        }
        return this.PesquisaEstudanteFinanceiro(val);
      }
    },
  },

 async created() {
  this.contadorAbertura++;
    // check if classe has been selected otherwise send back to painel to select
    if (!this.$store.state.idclasse || !this.$store.state.anolectivoSelected) {
      this.$router.push("/estudante/painelclasses");
    }
    this.config_estudantes_instituicao =
      this.$store.state.config_estudante_instituicao;
    // this.CarregActividades()
    // this.initialize()
    await this.InitializeCadastrados(this.$store.state.idclasse);
    this.initializeProvincias();
    this.initializeMunicipiosAll();
    this.initializeCursos();
    this.initializeturmasAll();
  },

  methods: {
    abrirComponente() {
      this.dialog = true;
      this.contadorAbertura++;
    },

    
    close() {
      this.dialog = false;
      this.isDisabled=false;
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },
    

    async checkDocNumber() {
      if (this.editedItem.bi) {
        try { 
          let response = await axios.get(`/vericarBIEstudante/${this.editedItem.bi}`).then((res) => res.data);
          if (response.length) {
            this.existingBi = true;
            this.studenteBi = response[0];
            this.studenteBi.classe = this.getClasse(parseInt(this.studenteBi.idano_academico));
            this.isDisabled = false;
          }
          else {
            this.existingBi = false;
            this.isDisabled=true;
          } 
          if (this.existingBi) {
            this.isDisabled=false;
            this.valid=true;
            let htmlContent = `
                <p style="text-align: center;"><strong style="color: red;">OBS:</strong> O número de bilhete inserido está sendo usado por outro estudante. Verifique novamente o número inserido. Se estiver correto e você continua recebendo este aviso, por favor, entre em contato com os administradores do sistema.</p>
                <div style="width: 90%; margin: 10 auto;">
                  <div style="display: grid; grid-template-columns: 150px auto;">
                    <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1); padding: 4px;"><strong>Nome:</strong></div>
                    <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1); padding: 4px;"> ${this.studenteBi.nome}</div>
                    <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1); padding: 4px;"><strong>Instituição:</strong></div>
                    <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1); padding: 4px;"> ${this.studenteBi.instituicaodescricao}</div>
                  </div>
                </div>
              `;
              Swal.fire({
                title: 'Atenção',
                html: htmlContent,
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: 'Fechar',
              })

          } else {
            //if (this.$refs.form.validate()) {
              //this.$refs.form.resetValidation()
              this.secondStep = true;
              this.valid=true;
              
           // }
          }
        } catch (error) {
          this.$refs.snackbar.mostrar(
            "Erro ao verificar o número de documento!",
            "error",
            "top",
          );
        }
      }
    },


    async InitializeCadastrados(classe) {
      try {
        this.cadastrados = await axios
          .post("/estudantes_cadastrados", {
            classe: classe,
            anolectivo: this.anolectivoSelected,
          })
          .then((res) => res.data);
      } catch (error) {
        this.$store.dispatch("textMessage", {
          msg: "Ocorreu um erro ao tentar efectuar a operação.",
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    getClasse(idclasse) {
      switch (idclasse) {
        case 1:
          return "10ª classe";
        case 2:
          return "11ª classe";
        case 3:
          return "12ª classe";
        case 4:
          return "13ª classe";
      }
    },

    async pesquisarPagamentoMatricula(params) {
      try {
        // this.isLoading = true
        return await axios
          .post("/verificaPagamentoEstudante", params)
          .then((res) => res.data);
      } catch (error) {
        this.$store.dispatch("textMessage", {
          msg: "Ocorreu um erro ao tentar efectuar a operação.",
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    async PesquisaEstudanteFinanceiro(searchDB) {
      this.isLoading = true;
      this.isLoading_ = true;
      if (!this.estudantesPesquisa.length) {
        if (searchDB) {
          var payload = '{ "find" : "' + searchDB + '" }';
        } else {
          payload = '{ "find":"all" }';
        }
        try {
          // this.isLoading = true
          this.estudantesPesquisa = await axios
            .get("/listarEstudantesCadastrados/" + payload)
            .then((res) => res.data);
          this.isLoading = false;
          this.isLoading_ = false;
        } catch (error) {
          this.isLoading = false;
          this.isLoading_ = false;
          this.text = error;
          this.$store.dispatch("textMessage", {
            msg: this.text,
            classMessage: "msgError",
            timeout: 3000,
          });
        }
      }
      this.isLoading = false;
      this.isLoading_ = false;
    },

    async SelecionaEstudante() {
      let estudante = this.editedItem.estudante;
      try {
        this.overlayPesquisa = true;
        let pagamnentosEstudante = await this.pesquisarPagamentoMatricula({
          estudante: estudante,
          anolectivo: ls.get("anolectivo"),
          emolumento: "Matrícula",
        });
        if (pagamnentosEstudante.length) {
          Object.assign(this.editedItem, this.editedItem.estudante);
          this.editedItem.bi = this.editedItem.estudante.bi;
          this.editedItem.nomedopai = this.editedItem.estudante.nomedopai;
          this.editedItem.nomedamae = this.editedItem.estudante.nomedamae;
          this.editedItem.sexo = "";
          let provinciaObjecto = this.provincias.filter(
            (p) => p.descricao === this.editedItem.estudante.provincia
          )[0];
          let municipiosFil = this.municipiosAll.filter(
            (municipio) =>
              municipio.idProvincia === provinciaObjecto.idProvincia
          );
          let municipioObjecto = municipiosFil.filter(
            (m) => m.idMunicipio === this.editedItem.estudante.idMunicipio
          )[0];
          this.proviSelectedForComb = provinciaObjecto;
          this.municSelectedForComb = municipioObjecto;

          // Filtra o curso e a classe
          let cursoObjecto = this.cursos.filter(
            (c) => c.idCurso === this.editedItem.estudante.idCurso
          )[0];
          this.editedItem.curso = cursoObjecto;
          this.loadTurmaComb();
          this.overlayPesquisa = false;
        } else {
          this.$store.dispatch("textMessage", {
            msg: "Estudante não pagou a Matrícula.",
            classMessage: "msgError",
            timeout: 3000,
          });
        }
        this.overlayPesquisa = false;
      } catch (error) {
        this.overlayPesquisa = false;
        this.$store.dispatch("textMessage", {
          msg: "Ocorreu um erro ao tentar efectuar a operação.",
          classMessage: "msgError",
          timeout: 3000,
        });
      } finally {
        this.overlayPesquisa = false;
      }
    },

    async initialize(searchInDb) {
      try {
        //   let  payload =""
        if (!searchInDb) {
          var payload =
            '{"anoacademico":"' +
            this.$store.state.idclasse +
            '","find":"all"}';
        } else {
          // eslint-disable-next-line no-redeclare
          var payload =
            '{"anoacademico":"' +
            this.$store.state.idclasse +
            '","find":"' +
            searchInDb +
            '"}';
        }

        this.isLoading = true;
        this.estudantes = await axios
          .get("/estudanteFindAll/" + payload)
          .then((res) => res.data);
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    }, // combo qua depende de outra combo
    // METHODO FOR VALIDATION
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    // END METHOD FOR VAL
    outroDoc() {      
      if (this.descricao === "Outro Doc.") {
        this.outroDocmento = false;
        this.editedItem.bi = "";
        this.descricao = "Nº do Bi";
        this.mascara = "#########-AA-###";
        this.ruleBI = [
          (value) =>
            value.length === 16 || "Minimo de caracteres exigido( 16 )",
        ];
      } else {
        this.outroDocmento = true;
        this.editedItem.bi = "";
        this.descricao = "Outro Doc.";
        this.mascara = "XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX";
        this.ruleBI = [
          (value) =>
            value.length >= 3 || "Minimo de caracteres exigido(3)",
        ];
      }
    },

    loadTurmaComb() {
      // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(
        (t) => t.idCurso === this.editedItem.curso.idCurso
      );
      this.$nextTick(() => {
        this.editedItem.turma = undefined;
      });
    },

    loadMunicipioComb(provincia) {
      this.$nextTick(() => {
        this.municSelectedForComb = undefined;
      });
      // eslint-disable-next-line no-return-assign
      return (this.municipiosFiltered = this.municipiosAll.filter(
        (municipio) => municipio.idProvincia === provincia.idProvincia
      ));
    },

    async initializeMunicipiosAll() {
      try {
        this.isLoading = true;
        this.municipiosAll = await axios
          .get("/municipioFindAll")
          .then((res) => res.data);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;

        this.text = error;
      }
    },

    async initializeProvincias() {
      try {
        this.isLoading = true;
        this.provincias = await axios
          .get("/provinciaFindAll")
          .then((res) => res.data);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;

        this.text = error;
      }
    },

    async CarregActividades() {
      try {
        this.$store.state.actividades = await axios
          .get("/listAberturaFechoInstituicao")
          .then((res) => res.data);
      } catch (error) { }
    },

    async initializeCursos() {
      try {
        this.isLoading = true;
        this.cursos = await axios.get("/cursoFindAll").then((res) => res.data);

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    async initializeturmasAll() {
      //  turmaFindWithEstudanteCount
      try {
        this.isLoading = true;
        this.turmasAll = await axios
          .get(
            "/turmaFindAll/" + this.idclasse + "/" + this.anolectivoSelecionado
          )
          .then((res) => res.data);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;

        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    editItem(item) {
      this.editedIndex = this.estudantes.indexOf(item);
      this.editedItem = Object.assign({}, item);

      // let v=  Object.assign({},  this.municipios[5]);
      try {
        // prara trazer valores default na combo
        // procura na collecao ja carregada
        this.municSelectedForComb = this.municipiosAll.filter(
          (mun) => mun.idMunicipio === item.idMunicipio
        );
        // seta o valor encontrado
        this.municSelectedForComb = this.municSelectedForComb[0];

        this.proviSelectedForComb = this.provincias.filter(
          (prov) => prov.idProvincia === this.municSelectedForComb.idProvincia
        );

        this.proviSelectedForComb = this.proviSelectedForComb[0];
      } catch (error) {
        this.$store.dispatch("textMessage", {
          msg: error,
          classMessage: "msgError",
          timeout: 3000,
        });
      }

      this.dialog = true;
    },

    deleteItem(item) {
      const index = this.estudantes.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.delete(item.pkPessoa);
      // this.estudantes.splice(index, 1)
    },

    async obterCadastradosTurma (){

      try {
 
          this.overlay = true
          this.cadastradosTurma = await axios.post('/obterCadastradosTurma',{turma:this.editedItem.turma}).then((res)=>res.data)
        
      } catch (error) {
        this.$refs.snackbar.mostrar(
          "Ocorreu um erro ao carregar as informações da turma",
          "error",
          "top",
        );
      }finally{
        this.overlay = false
      }
              
    },

    saveDate(date) {
      this.$refs.menu.save(date);
      this.editedItem.datanascimento = date;

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10);
    },

    saveDatebi(datebi) {
      this.$refs.menubi.save(datebi);
      this.editedItem.dataemissaobi = datebi;

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.datebi = new Date(date).toISOString().substr(0, 10);
    },

    async save() {
  if (this.$refs.form.validate()) {
    this.isLoading = true; // Ativar estado de carregamento
    
    let ano_nascimento = this.editedItem.datanascimento.toString().split("-")[0];

    if (this.ano_actual - ano_nascimento >= 14) {
      const ls = require("local-storage");
          var params = {
            pkPessoa: this.editedItem.pkPessoa,
            idPEssoa: this.editedItem.bi,
            idMunicipio: this.municSelectedForComb.idMunicipio,
            idPerfil: 1,
            nome: this.editedItem.nome,
            morada: this.editedItem.morada,
            telefone: this.editedItem.telefone,
            autor: ls.get("idPessoa"),
            datanascimento: this.editedItem.datanascimento,
            data_: this.editedItem.data_,
            status_2: this.editedItem.status_2,
            email: this.editedItem.email,
            sexo: this.editedItem.sexo.idSexo,
            nomedopai: this.editedItem.nomedopai,
            nomedamae: this.editedItem.nomedamae,
            dataemissaobi: this.editedItem.dataemissaobi,
            bi: this.editedItem.bi,
            ResidenteEm: 1,
            instituicao: ls.get("i_id"),
            instituicaodescricao: ls.get("instituicaodescricao"),
            curso: this.editedItem.curso,
            turma: this.editedItem.turma,
            anolectivo: this.anolectivoSelecionado,
            idanolectivo: ls.get("idanolectivo"),
            idanoacademico: this.idclasse,
            outroDocmento: this.outroDocmento,
            turma_uuid: this.editedItem.turma.uuid,
            numero_matricula: this.editedItem.idMatricula,
            isIntegrado: this.isBendizer,
          };

          let estudanteCadastrado = {
            nome: params.nome,
            turma: params.turma.idTurma,
            bi: params.bi,
          };

          let htmlContent = `
            <p style="text-align: center;"><strong style="color: red;">OBS:</strong> Confirme os dados antes de finalizar o cadastramento.</p>
            <div style="width: 90%; margin: 10 auto;">
              <div style="display: grid; grid-template-columns: 150px auto;">
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Nome:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.nome}</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Bilhete:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.bi}</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Curso:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.curso.descricao}</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Classe:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${this.getClasse(params.idanoacademico)}</div>
                <div style="text-align: left; border-bottom: 2px solid rgba(0, 0, 0, 0.1);"><strong>Turma:</strong></div>
                <div style="text-align: right; border-bottom: 2px solid rgba(0, 0, 0, 0.1);">${params.turma.turmadescricao}</div>
              </div>
            </div>
          `;

          Swal.fire({
        title: "Cadastrar Estudante",
        html: htmlContent,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "green",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Guardar",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            let msg = await axios
              .post("/estudanteInsertOrUpdate", params)
              .then((res) => res.data);

            if (msg === "Inserção ou Actualização feita com sucesso") {
              this.$refs.snackbar.mostrar(
                "Estudante cadastrado com sucesso",
                "success",
                "top",
              );
              this.reset();
              this.$refs.form.reset();
              this.$refs.biField.reset();
              this.editedItem.bi = null;

              this.InitializeCadastrados(this.$store.state.idclasse);
              this.estudantes.unshift(estudanteCadastrado);
              this.close();
            } else {
              this.$refs.snackbar.mostrar(
                msg,
                "warning",
                "top",
              );
            }
          } catch (error) {
              console.log(error);
            this.$refs.snackbar.mostrar(
              "Erro ao cadastrar estudante",
              "error",
              "top",
            );
          } finally {
            this.isLoading = false; // Sempre redefinir para permitir cliques
          }
        } else {
          this.isLoading = false; // Caso o usuário cancele, reabilita os botões
        }
      });
    } else {
      this.text = `O estudante tem a idade ('${this.ano_actual - ano_nascimento}' anos) inferior à permitida pelo sistema. (Idade mínima: 14 anos)`;
      this.$store.dispatch("textMessage", {
        msg: this.text,
        classMessage: "msgError",
        timeout: 8000,
      });
      this.isLoading = false; // Caso de erro de idade, reabilita os botões
    }
  }
},


    getClasse(idclasse) {
      switch (idclasse) {
        case 1:
          return "10ª classe";
        case 2:
          return "11ª classe";
        case 3:
          return "12ª classe";
        case 4:
          return "13ª classe";
      }
    },

    async delete(idv) {
    
      try {
        var msg = await axios
          .get("/estudanteDeleteById/" + idv)
          .then((res) => res.data);
        this.text = "Deleted " + msg.message;

        this.initialize();
      } catch (error) {
        this.text = error.message;
      } finally {
      }
    },
  },
};
</script>
<style scoped>
.bg {
  color: green;
  background: red;
}

</style>
